import { inject, Injectable, Injector } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from "../../../environments/environment";
import { StoreService } from './store.service';
import { UserService } from '@core/auth/user/user.service';
@Injectable({
  providedIn: 'root'
})
export class CryptoService {
  private injector: Injector = inject(Injector);

  token: any;
  constructor(
    private store: StoreService
  ) { }

  aesEncrypt(data: any) {
    let key: string = environment.aesEnckey as string; //length 32
    let iv: string = environment.aesEnciv as string;
    let cipher = CryptoJS.AES.encrypt(JSON.stringify(data), CryptoJS.enc.Utf8.parse(key), {
      iv: CryptoJS.enc.Utf8.parse(iv),
      mode: CryptoJS.mode.CBC,
    });
    return cipher.toString();
  }
  aesDecrypt(data: any) {
    let key: string = environment.aesEnckey as string; //length 32
    let iv: string = environment.aesEnciv as string;
    let cipher = CryptoJS.AES.decrypt(data, CryptoJS.enc.Utf8.parse(key), {
      iv: CryptoJS.enc.Utf8.parse(iv),
      mode: CryptoJS.mode.CBC,
    });
    return cipher.toString(CryptoJS.enc.Utf8);
  }


  private CryptoJSAesJson = {
    stringify: function (cipherParams: any) {
      let j: any = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) };
      if (cipherParams.iv) j.iv = cipherParams.iv.toString();
      if (cipherParams.salt) j.s = cipherParams.salt.toString();
      return JSON.stringify(j);
    },
    parse: function (jsonStr: any) {
      let j: any = JSON.parse(jsonStr);
      let cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext: CryptoJS.enc.Base64.parse(j.ct) });
      if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv)
      if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s)
      return cipherParams;
    }
  }

  encrypt(data: any) {
    return CryptoJS.AES.encrypt(JSON.stringify(data), this.getKey(), { format: this.CryptoJSAesJson }).toString();
  }

  decrypt(body: any) {
    try {
      const bytes = CryptoJS.AES.decrypt(JSON.stringify(body), this.getKey(), { format: this.CryptoJSAesJson });
      console.log(bytes);

      const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
      console.log(decryptedString);

      const decryptedData = JSON.parse(decryptedString);
      console.log(decryptedData);

      return decryptedData
    } catch (error) {
      console.error('Decryption error:', error);
    }
    // return JSON.parse(CryptoJS.AES.decrypt(body, this.getKey(), { format: this.CryptoJSAesJson }).toString(CryptoJS.enc.Utf8));
  }

  private getKey() {

    const token = this.injector.get(UserService).loginData?.authtoken ?? null;
    if (token) {
      let authtoken = this.aesDecrypt(token);
      let desc = JSON.parse(authtoken);
      this.token = desc.authtoken;
    } else {
      this.token = '';
    }

    if (!this.token) {
      return environment.defEncKey;
    }
    let key = this.token;
    key = key.replace('Bearer ', '');
    key = key.replace(/X/g, 'a');
    key = key.replace(/x/g, 'A');
    key = key.replace(/(.)(.)(.)/g, "$1$2");
    return key;
  }

}
